const getPlateVehicleResults = async ({domain, km, plate}) => {
  if (!plate) return {}

  const [error, response] = await domain.get('get_vehicles_info_by_plate_use_case').execute({plate})
  if (error) return {hasPlateError: true}

  return {plateVehicleResults: {km, plate, vehicles: [...response.items]}}
}

const getInitialProps = async ({routeInfo, context: {i18n, domain}}) => {
  const {
    location: {
      pathname: path,
      query: {km, plate, postalCode}
    }
  } = routeInfo

  const {PUBLISH_MY_AD_CATEGORY_PATH_PATTERN} = domain.get('config').get('page')

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

  const [[, seoDataResponse], {hasPlateError, plateVehicleResults}] = await Promise.all([
    domain.get('get_seo_data_use_case').execute({culture: i18n.culture, pageName}),
    getPlateVehicleResults({domain, km, plate})
  ])

  if (hasPlateError) return {__HTTP__: {redirectTo: `${PUBLISH_MY_AD_CATEGORY_PATH_PATTERN}?hasPlateError=true`}}

  return {
    h1: seoDataResponse?.h1 || '',
    helmet: seoDataResponse?.head || {},
    pageName,
    plateVehicleResults,
    postalCode
  }
}

export {getInitialProps}
